module.exports = __webpack_public_path__ + "assets/7d490f23da47d72b17046ae58434f522.mp3";